module.exports = "/_next/static/images/ea28e0d8e8ff7e21c87219a88f5a1082-phone-and-card@md-1x.jpg.webp";